import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Star, CheckCircle, Infinity as InfinityIcon } from 'lucide-react';
import { Btn } from '@/presentation/component/ui';

export const HomePage = () => {
  const { t } = useTranslation();

  return (
    <div>
      <section className="bg-gradient-to-r from-blue-600 to-purple-700 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-24">
          <div className="text-center">
            <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold mb-6">
              {t('home.heroTitle')}
              <span className="block text-yellow-400">{t('home.heroSubtitle')}</span>
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl mb-8 max-w-3xl mx-auto opacity-90">
              {t('home.heroDescription')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/formation">
                <Btn
                  kind="default"
                  size="lg"
                  className="w-full sm:w-auto bg-white text-blue-600 border-blue-600 hover:bg-blue-50"
                >
                  {t('buttons.browseAllCourses')}
                </Btn>
              </Link>
              <Link to="/signup">
                <Btn
                  kind="ghost"
                  size="lg"
                  className="w-full sm:w-auto border-white text-white hover:bg-white/10"
                >
                  {t('buttons.startFree')}
                </Btn>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-20 bg-[var(--color-surface)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[var(--color-ink)] mb-4">
              {t('home.whyChooseTitle')}
            </h2>
            <p className="text-lg sm:text-xl text-[var(--color-ink-soft)] max-w-2xl mx-auto">
              {t('home.whyChooseDescription')}
            </p>
          </div>

          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-[var(--color-accent-soft)] rounded-full flex items-center justify-center mx-auto mb-4">
                <Star className="w-8 h-8 text-[var(--color-accent)]" />
              </div>
              <h3 className="text-xl font-semibold text-[var(--color-ink)] mb-2">
                {t('home.expertInstructorsTitle')}
              </h3>
              <p className="text-[var(--color-ink-soft)]">{t('home.expertInstructorsDesc')}</p>
            </div>

            <div className="text-center p-6">
              <div className="w-16 h-16 bg-[var(--color-good-bg)] rounded-full flex items-center justify-center mx-auto mb-4">
                <CheckCircle className="w-8 h-8 text-[var(--color-good)]" />
              </div>
              <h3 className="text-xl font-semibold text-[var(--color-ink)] mb-2">
                {t('home.flexibleLearningTitle')}
              </h3>
              <p className="text-[var(--color-ink-soft)]">{t('home.flexibleLearningDesc')}</p>
            </div>

            <div className="text-center p-6 sm:col-span-2 md:col-span-1">
              <div className="w-16 h-16 bg-[var(--color-accent-soft)] rounded-full flex items-center justify-center mx-auto mb-4">
                <InfinityIcon className="w-8 h-8 text-[var(--color-accent)]" />
              </div>
              <h3 className="text-xl font-semibold text-[var(--color-ink)] mb-2">
                {t('home.lifetimeAccessTitle')}
              </h3>
              <p className="text-[var(--color-ink-soft)]">{t('home.lifetimeAccessDesc')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-20 bg-[var(--color-surface-2)]">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[var(--color-ink)] mb-4">
            {t('home.readyToStartTitle')}
          </h2>
          <p className="text-lg sm:text-xl text-[var(--color-ink-soft)] mb-8">
            {t('home.readyToStartDesc')}
          </p>
          <Link to="/formation">
            <Btn kind="primary" size="lg">
              {t('buttons.explore')}
            </Btn>
          </Link>
        </div>
      </section>
    </div>
  );
};
